// The carousel swipe is tracked programmatically through a ref, so its id is not written as a
// literal string argument the registry guard test can scan for. Keeping the id here lets a
// dedicated test assert it resolves to a registry entry instead.
export const PHOTO_CAROUSEL_SWIPE_ANALYTICS_ID =
  'product_card_photo_carousel_swipe_gallery_view'
